<!--  -->
<template>
  <div class="BottomAxis">
    <p>朝九晚四 (广州)网络科技有限公司</p>
    <p>粤ICP备2021090037号-1</p>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="less" scoped>
.BottomAxis {
  width: 100%;
  text-align: center;
  padding: 24px 0 52px 0;
  font-size: 14px;
  color: #666666;

  line-height: 20px;
}
</style>
